import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import useIsMobile from 'utils/hooks/useIsMobile';

import './Layout.scss';

/**
 * Layout da tela Weol-SH (FE-WINDX-050).
 *
 * Renderiza sub-tabs Semi-horário | Diário como navegação secundária — mesmo
 * pattern do <SemanalLayout> (FE-WINDX-018), distinto do TabbedPage do
 * <WindxWrapper> top-level.
 *
 * Hierarquia visual:
 *   <WindxWrapper> (top-level — TabbedPage, abas grandes):
 *     [WEOL-SH]      [WEOL-SM]
 *         \
 *          <SemiHorarioLayout> (sub-nav — links com sublinhado):
 *            Semi-horário | Diário
 *                       \
 *                        <Outlet /> -> SemiHorario (mesmo componente para ambos)
 *
 * O Outlet renderiza o mesmo componente <SemiHorario /> para os dois sub-tabs.
 * A diferença operacional vem do Redux (`granularidadeSH`), sincronizado a
 * partir do path em <WindxWrapper> e mapeado para `frequencia_temporal` nos
 * requests do <GraficoSH>.
 */
export default function WindxSemiHorarioLayout() {
  const isMobile = useIsMobile();

  return (
    <div className="windx-sh-layout">
      <nav
        className={`windx-sub-nav${isMobile ? ' windx-sub-nav--mobile' : ''}`}
        aria-label="Sub-tabs Weol-SH"
      >
        <NavLink to="/windx/automatic/semi-horario" className="windx-sub-nav__link">
          Semi-horário
        </NavLink>
        <NavLink to="/windx/automatic/diario" className="windx-sub-nav__link">
          Diário
        </NavLink>
      </nav>

      <div className="windx-sub-nav__content">
        <Outlet />
      </div>
    </div>
  );
}
